import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { SupplementaryEquipmentSelectionItem } from '../../register-entrance-leave.model';
import { SupplementaryEquipment } from '../../../../components/visit-overview/model/supplementary-equipment-handout';

@Component({
    selector: 'app-supplementary-equipment-item',
    templateUrl: './supplementary-equipment-item.component.html',
    styleUrls: ['./supplementary-equipment-item.component.scss'],
    standalone: false
})
export class SupplementaryEquipmentItemComponent implements OnInit {

  @Input() supplementaryEquipment: SupplementaryEquipment;

  @Output() changed = new EventEmitter<SupplementaryEquipmentSelectionItem>();

  selected = false;

  formGroup = new FormGroup({
    checked: new FormControl(false, []),
    identifier: new FormControl(null, []),
  });

  constructor() { }

  ngOnInit(): void {

    this.formGroup.valueChanges.subscribe(value => {
      this.selected = value.checked === true;
      this.changed.next(new SupplementaryEquipmentSelectionItem({
        equipmentTypeId: this.supplementaryEquipment.equipmentTypeId,
        checked: value.checked === true,
        selectedIdentifier: value.identifier ?? undefined,
      }));
    });

  }

}
